﻿'use strict';
import Axios from "axios";
import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";
const plugins = [CSSPlugin, ScrollToPlugin];


export default class Admin {

    constructor() {

        if (!d.querySelector("#adminClasses")) {
            return;
        }

        const AddModalButtons = () => {
            const allButtons = d.querySelectorAll(".more_info");

            if (allButtons) {
                allButtons.forEach((card, i) => {

                    card.addEventListener("click", (e) => {

                        var btn = e.currentTarget;
                        if (btn) {
                            window.registrationModal.OpenRegModalXHR(btn.dataset.organizationid, btn.dataset.classid);
                        }
                    });
                });

            }
        };

        const FetchAndUpdatePage = () => {


            Axios.get("/registrations").then((result) => {
                const nePage = document.createRange().createContextualFragment(result.data);
                d.querySelector("#dynamicClasses").innerHTML = nePage.querySelector("#dynamicClasses").innerHTML;
                TweenLite.to(d.querySelector(".glow"), .5, {delay: 5, alpha: 0 });
                AddModalButtons();
            });
        }

        const PYCHub = $.connection.pYCHub;

        try {
            $.connection.hub.start().done(function () {
                //   console.log("starting hub for admin");
            });

            PYCHub.client.Refesh = (orgId) => {

                const orgList = d.querySelector("#OrganizationId").value.split(",");


                if (d.querySelector("#OrganizationId").value == "" || orgList.indexOf(orgId.toString()) >= 0) {
                    FetchAndUpdatePage();
                }
            };
        } catch (e) {

        }

        AddModalButtons();
        TweenLite.to(d.querySelector(".glow"), 0, { alpha: 0 });
    }
}